import { apiGet, apiPut } from './client'

export interface LiveRefresh {
  refresh_ms: number
}

export const getLiveRefresh = () => apiGet<LiveRefresh>('/settings/live-refresh')
export const putLiveRefresh = (refresh_ms: number) =>
  apiPut<LiveRefresh>('/settings/live-refresh', { refresh_ms })
